import { pricingRuleIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deletePricingRule = {
  name: "deletePricingRule" as const,

  input: z.object({ pricingRuleId: pricingRuleIdFormat.schema }),

  output: z.object({ success: z.boolean() }),
};
